import { render } from "./PaymentLinkPage.vue?vue&type=template&id=fae9c61e&scoped=true"
import script from "./PaymentLinkPage.vue?vue&type=script&lang=js"
export * from "./PaymentLinkPage.vue?vue&type=script&lang=js"

import "./PaymentLinkPage.vue?vue&type=style&index=0&id=fae9c61e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae9c61e"]])

export default __exports__